import React, { useEffect } from 'react';
import { useAppDispatch } from 'stores/type';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { Redirect, useHistory } from 'react-router-dom';
import { Splash } from 'views/components/molecules/Splash';
import queryString from 'query-string';
import { useIntl } from 'react-intl';
import { closeDialog, showDialog } from 'stores/dialogSlice';
import { localeIds } from 'locals';
import { setExceptionError } from 'stores/errorSlice';
import { ROUTER_PATH } from 'views/constants';
import { useDevice } from 'views/hooks/useDevice';
import { ApplicationError } from 'models/Error';

export const LoginFromOAuthPage: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const { loginFromOAuth } = useDevice();

  const onetimeToken = queryString.parse(location.search)[
    'ios_spa_onetime_token'
  ] as string;
  useEffect(() => {
    if (!onetimeToken) {
      return;
    }

    loginFromOAuth(onetimeToken)
      .then(() => {
        history.replace(ROUTER_PATH.apps);
      })
      .catch((e) => {
        if (e instanceof ApplicationError) {
          dispatch(
            showDialog({
              content: intl.formatMessage({ id: e.localeId() }),
              defaultAction: {
                label: intl.formatMessage({ id: localeIds.dialog.ok }),
                callback: () => {
                  dispatch(closeDialog());
                  history.replace(ROUTER_PATH.login);
                },
              },
            })
          );
        } else {
          dispatch(setExceptionError(e));
        }
      });
  }, [onetimeToken]);

  if (!onetimeToken) {
    return <Redirect to={ROUTER_PATH.login} />;
  } else {
    return (
      <DefaultTemplate headerText="">
        <Splash />
      </DefaultTemplate>
    );
  }
};
